export default "__VITE_ASSET__BUjwIZh5__"